import ModelUtil from '@leverege/model-util';
const TYPE = 'rsrc.SortModel';
const ALLOWED_SORTS = ['id', 'projectId', 'ownerId', 'coownerId', 'path', 'type', 'createdAt', 'updatedAt'];
function create() {
  return {
    type: TYPE,
    sorts: [{
      field: 'createdAt',
      order: 'DESC'
    }]
  };
}
function toRsrcOrder(model) {
  const sorts = model?.sorts;
  const order = [];
  sorts.forEach(s => {
    if (!ALLOWED_SORTS.includes(s.field)) {
      return;
    }
    order.push([s.field, s.order.toUpperCase()]);
  });
  return order.length > 0 ? order : null;
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllArray('sorts', 'Sort', 'Sorts'),
  toRsrcOrder
};